module.exports = __webpack_public_path__ + "624c1255/img/33000000-0.9957429d.png";